import { render, staticRenderFns } from "./CloudSetup.vue?vue&type=template&id=70aaccbe&"
import script from "./CloudSetup.vue?vue&type=script&lang=js&"
export * from "./CloudSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports